import styled, { css } from "styled-components";

import { Breakpoint, screenBelow } from "../BreakPoints";
import { Space, SPACE } from "../LayoutTokens";

export const StyledTiles = styled.div<{
  $cols: number;
  $space: Space;
  $collapse?: Breakpoint;
}>`
  display: grid;
  grid-template-columns: repeat(${({ $cols }) => $cols}, minmax(0, 1fr));
  gap: ${({ $space }) => SPACE[$space]};

  ${({ $collapse }) =>
    $collapse &&
    css`
      ${screenBelow[$collapse]} {
        grid-template-columns: minmax(0, 1fr);
      }
    `}
`;

StyledTiles.displayName = "StyledTiles";
